import { render, staticRenderFns } from "./Tab5.vue?vue&type=template&id=3c6fa78b&scoped=true"
import script from "./Tab5.vue?vue&type=script&lang=js"
export * from "./Tab5.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/pei/parte-k.css?vue&type=style&index=0&id=3c6fa78b&prod&scoped=true&lang=css&external"
import style1 from "./Tab5.vue?vue&type=style&index=1&id=3c6fa78b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6fa78b",
  null
  
)

export default component.exports